import { CompanyAvatarForm, CompanyDeleteForm, CompanyNameForm, CompanySlugForm } from "modules/company";
import { useRouter } from "next/router";
import React from "react";
import { CompanySettingsLayout } from "./_layout";

const CompanySettingsPage = () => {
  const { query } = useRouter();
  const companySlug = query.company as string;

  return (
    <CompanySettingsLayout>
      {/*<Section>*/}
      {/*  <CompanyFinancialDayForm companySlug={companySlug} />*/}
      {/*</Section>*/}
      <CompanyAvatarForm companySlug={companySlug} />
      <CompanyNameForm companySlug={companySlug} />
      <CompanySlugForm companySlug={companySlug} />
      <CompanyDeleteForm companySlug={companySlug} />
    </CompanySettingsLayout>
  );
};

export default CompanySettingsPage;
